// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1mJQc","rootCenter":"LoadMoreObserver_rootCenter__1jdCG","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1Rnsx"};